<div class="service-page">
  <header class="page-hero">
    <h1>Una web cuidada después de su publicación.</h1>
    <p class="hero-lead">
      Mantenimiento para conservar una web estable y actualizada, atender incidencias y valorar
      mejoras conforme evoluciona el negocio.
    </p>
    <a class="button button-primary" routerLink="/contacto">Consultar mantenimiento</a>
  </header>

  <section class="split-section" aria-labelledby="maintenance-need-title">
    <div class="section-heading">
      <h2 id="maintenance-need-title">
        Publicar una web no significa dejar de prestarle atención.
      </h2>
    </div>
    <ul class="check-list">
      <li>No tienes un seguimiento técnico definido.</li>
      <li>Necesitas atender actualizaciones o incidencias.</li>
      <li>La información y las necesidades del negocio cambian.</li>
      <li>Quieres valorar mejoras de manera ordenada.</li>
    </ul>
  </section>

  <section aria-labelledby="maintenance-scope-title">
    <div class="section-heading">
      <h2 id="maintenance-scope-title">Soporte ajustado al estado y la tecnología de cada web.</h2>
      <p>Las tareas incluidas y sus límites deben acordarse después de revisar el proyecto.</p>
    </div>
    <div class="feature-grid feature-grid-three">
      <article>
        <span>01</span>
        <h3>Actualizaciones</h3>
        <p>Revisión de los elementos técnicos que formen parte del alcance acordado.</p>
      </article>
      <article>
        <span>02</span>
        <h3>Incidencias</h3>
        <p>Un canal definido para analizar problemas relacionados con la web mantenida.</p>
      </article>
      <article>
        <span>03</span>
        <h3>Mejoras</h3>
        <p>Valoración separada de cambios que amplíen o modifiquen el alcance existente.</p>
      </article>
    </div>
  </section>

  <section class="pricing-plans" aria-labelledby="maintenance-price-title">
    <div class="section-heading">
      <h2 id="maintenance-price-title">Soporte separado del alojamiento.</h2>
      <p>
        El mantenimiento no incluye el hosting. Puede contratarse independientemente de dónde esté
        alojada la web. Los precios indicados no incluyen IVA.
      </p>
    </div>

    <div class="pricing-grid">
      <article class="pricing-card">
        <p class="plan-name">Mantenimiento esencial</p>
        <h3>59 €/mes + IVA</h3>
        <p>Para webs que necesitan supervisión y soporte básico.</p>
        <h4>Incluye</h4>
        <ul>
          <li>Revisiones periódicas y comprobación general de funcionamiento.</li>
          <li>Actualizaciones técnicas necesarias.</li>
          <li>Soporte ante incidencias menores y corrección de pequeños errores.</li>
          <li>Cambios menores de contenido.</li>
          <li>Revisión básica de formularios y enlaces.</li>
          <li>Recomendaciones cuando se detecte algún problema.</li>
        </ul>
        <p class="plan-note">
          No incluye nuevas páginas, rediseños, funcionalidades ni cambios de alcance.
        </p>
      </article>

      <article class="pricing-card featured-plan">
        <p class="plan-name">Mantenimiento profesional</p>
        <h3>149 €/mes + IVA</h3>
        <p>Para negocios que necesitan seguimiento más frecuente y evolución continua.</p>
        <h4>Incluye todo lo anterior, además de</h4>
        <ul>
          <li>Mayor prioridad de soporte y resolución prioritaria de incidencias.</li>
          <li>Cambios recurrentes de contenido y ajustes visuales menores.</li>
          <li>Revisión periódica de rendimiento y SEO técnico.</li>
          <li>Seguimiento de formularios e integraciones.</li>
          <li>Pequeñas mejoras evolutivas dentro de los límites acordados.</li>
        </ul>
        <p class="plan-note">
          Los desarrollos relevantes o nuevas funcionalidades se presupuestarán aparte.
        </p>
      </article>

      <article class="pricing-card">
        <p class="plan-name">Mantenimiento personalizado</p>
        <h3>Presupuesto a medida</h3>
        <p>Para proyectos avanzados con una dedicación adaptada a sus necesidades.</p>
        <h4>Puede incluir</h4>
        <ul>
          <li>Dedicación recurrente y evolutivos frecuentes.</li>
          <li>Soporte sobre funcionalidades críticas.</li>
          <li>Monitorización e intervenciones sobre backend.</li>
          <li>Gestión de integraciones.</li>
          <li>Acuerdos específicos de disponibilidad o respuesta.</li>
        </ul>
        <p class="plan-note">Se define según la complejidad y dedicación necesarias.</p>
      </article>
    </div>
  </section>

  <section class="faq-section" aria-labelledby="maintenance-faq-title">
    <div class="section-heading">
      <h2 id="maintenance-faq-title">Sobre el mantenimiento web.</h2>
    </div>
    <div class="faq-list">
      <details>
        <summary>¿Podéis mantener una web que no habéis desarrollado?</summary>
        <p>
          Se puede valorar, pero primero es necesario revisar su tecnología, estado y condiciones de
          acceso. Esa revisión determina si el servicio es viable.
        </p>
      </details>
      <details>
        <summary>¿El mantenimiento incluye cualquier cambio?</summary>
        <p>
          No se presupone. Las tareas recurrentes, la atención de incidencias y las mejoras deben
          quedar diferenciadas en la propuesta.
        </p>
      </details>
      <details>
        <summary>¿Cómo sé qué mantenimiento necesita mi web?</summary>
        <p>
          Puedes explicar qué tecnología utiliza, quién la gestiona ahora y qué necesidades tienes.
          Si faltan datos, habrá que revisar el proyecto.
        </p>
      </details>
    </div>
  </section>

  <section class="service-cta" aria-labelledby="maintenance-cta-title">
    <h2 id="maintenance-cta-title">Revisemos qué necesita tu web.</h2>
    <p>Cuéntanos su situación actual y el tipo de apoyo que estás buscando.</p>
    <a class="button button-primary" routerLink="/contacto">Solicitar una valoración</a>
  </section>
</div>
